stimulusApp.register(
  "room-filters",
  class extends Stimulus.Controller {
    static outlets = [
      "room-card",
      "room-filter-option",
      "group-accommodation-filter",
    ]
    static targets = ["moreCards", "cardsContainer", "filterContainer"]
    static values = {
      perPage: Number,
      partiallyHideCount: Number,
      cardsShown: Number,
    }

    cardsContainerTargetConnected(element) {
      element.addEventListener("animationend", (e) => {
        if (e.animationName === "fadeIn") {
          this.roomCardOutlets.forEach((outlet) => outlet.removeFadeIn())
        }
      })

      this.#filterCards({ cardsLoaded: true })
    }

    showMore() {
      this.cardsShownValue += this.perPageValue
      this.#updateCardsVisibility(this.#enabledFilters())
    }

    filter(event) {
      Activity.capture(
        `rooms filter ${event.target.checked ? "select" : "deselect"}`,
        { filter: { section: event.target.name, name: event.target.value } },
      )

      this.#filterCards({ cardsLoaded: false })
    }

    #filterCards({ cardsLoaded }) {
      requestAnimationFrame(() => {
        const currentFilters = this.#enabledFilters()

        if (this.#updateCardsVisibility(currentFilters)) {
          document.dispatchEvent(new Event("room-filters:applied"))
        } else {
          document.dispatchEvent(new Event("room-filters:removed"))
        }

        this.#updateCounters(currentFilters, cardsLoaded)

        if (this.hasGroupAccommodationFilterOutlet) {
          this.groupAccommodationFilterOutlet.toggle(cardsLoaded)
        }
      })
    }

    #updateCardsVisibility(currentFilters) {
      const hasActiveFilters = Object.keys(currentFilters).length > 0
      let visibleCards = hasActiveFilters
        ? this.roomCardOutlets.filter((outlet) => outlet.match(currentFilters))
        : this.roomCardOutlets

      this.roomCardOutlets.forEach((outlet) => outlet.hide())
      visibleCards.slice(0, this.cardsShownValue).forEach((card) => card.show())
      visibleCards
        .slice(
          this.cardsShownValue,
          this.cardsShownValue + this.partiallyHideCountValue,
        )
        .forEach((card) => card.partiallyHide())

      if (this.hasMoreCardsTarget) {
        if (visibleCards.length > this.cardsShownValue) {
          this.moreCardsTarget.classList.remove("hidden")
        } else {
          this.moreCardsTarget.classList.add("hidden")
        }
      }

      return hasActiveFilters
    }

    #updateCounters(currentFilters, cardsLoaded) {
      let result = {}

      this.roomFilterOptionOutlets.forEach((outlet) => {
        const filters = Object.assign({}, currentFilters, outlet.filter())
        const count = this.roomCardOutlets.filter((outletCard) =>
          outletCard.match(filters),
        ).length
        outlet.update(count, cardsLoaded)

        result[outlet.name()] ||= !outlet.element.classList.contains("hidden")
      })

      Object.entries(result).forEach(([name, visible]) => {
        const filter = this.filterContainerTargets.find(
          (target) => target.dataset.filterName === name,
        )
        filter.classList.toggle("hidden", !visible)
      })
    }

    #enabledFilters() {
      let result = {}

      this.roomFilterOptionOutlets.forEach((outlet) => {
        if (outlet.checked()) {
          const name = outlet.name()
          const data = outlet.filter()[name]
          result[name] = new Set([...(result[name] || []), ...data])
        }
      })

      return result
    }
  },
)
